/**
 * Controls body scroll locking for modal-like UI.
 * Uses reference counting so body classes are removed only when the last lock is released.
 */
export class BodyScrollLockService {
  private static lockCount = 0;

  private static updateBodyClasses(): void {
    const isLocked = this.lockCount > 0;
    document.body.classList.toggle('modal-open', isLocked);
    document.body.classList.toggle('overflow-hidden', isLocked);
  }

  public static acquire(): () => void {
    this.lockCount += 1;
    this.updateBodyClasses();

    let released = false;

    return () => {
      if (released) return;

      released = true;
      this.lockCount = Math.max(0, this.lockCount - 1);
      this.updateBodyClasses();
    };
  }
}
